// CONSTANTS are all caps.
const NS = "HubHero";
const CLS = "hubHero";
const WG = `.${CLS}-`;

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out src/scripts/loadWg/hubHero.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'


export class HubHero {

	constructor($el) {
		// $el is the widget node return by the loadHubHero function
		this.$el = $el;
	}

	init() {
		// added classes here instead of template because easier to maintain
		if(this.$el.querySelector("video"+WG+"video")) this.$el.classList.add("has-video");
		else if(this.$el.querySelector(".youtube-player"+WG+"video")) this.$el.classList.add("has-videoYT");

		this.playVideo();
	}

	playVideo() {
		$(document).on("youtubeVideoReady", () => {
			let $video = $(`${WG}video`);
			if ($video.length > 0) {
				youTubePlayers[$video.attr("data-array-index")].setVolume(0);
			}
		});
	}

	//Add more functions like on above here

}
